import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["id"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("p", {
        id: $setup.formDescriptionId,
        "data-slot": "form-description",
        class: _normalizeClass($setup.cn('text-muted-foreground text-sm', $setup.props.class))
    }, [
        _renderSlot(_ctx.$slots, "default")
    ], 10 /* CLASS, PROPS */, _hoisted_1));
}
